import { createSelector } from 'reselect';
import moment from 'moment';
import get from 'lodash/get';
import { cloneDeep, orderBy } from 'lodash';

import { ERR_CONFIG_DATE_FORMAT } from '@utils/constants';
import { SCOPE } from './types';
import { configViewSelector } from '../base/selectors';

const selector = (state) => get(state, SCOPE);

export const loadingSelector = createSelector(selector, (configState) => ({
  loading: configState.isFetching,
  showError: configState.errorCode !== 0,
  errorMsg: configState.errorMsg,
}));

export const dataSelector = createSelector(selector, (configState) =>
  configState.response ? configState.response.data : {},
);

export const configDataSortSelector = createSelector(
  configViewSelector,
  dataSelector,
  (configData, tableData) => {
    const sort = configData;
    const records = [];

    get(tableData, 'data', []).forEach((row) => {
      const value = row.rules.map((ele) => `Error ${ele.operator} ${ele.value}`).join(' OR ');
      // build row data
      const rowData = cloneDeep(row);
      const {
        updatedBy: { email, username },
      } = rowData;

      rowData.rules = value;
      rowData.rawRules = row.rules;
      rowData.updatedBy['email'] = email || username;

      // Remove deleted row
      if (rowData.state !== 0) {
        records.push(rowData);
      }
    });

    const orderedRecords = orderBy(records, [sort.key], [sort.order]);

    return {
      data: orderedRecords,
      sort,
    };
  },
);

export default selector;
